import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getVisitorId() {
  let id = localStorage.getItem("tq_visitor_id");
  if (!id) {
    id =
      (crypto.randomUUID && crypto.randomUUID()) ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("tq_visitor_id", id);
  }
  return id;
}

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + (location.hash || "");
    // Don't count the private admin dashboard.
    if (path.startsWith("/admin")) return;
    axios
      .post(`${API}/analytics/pageview`, {
        path,
        referrer: document.referrer || "",
        visitor_id: getVisitorId(),
      })
      .catch(() => {});
  }, [location.pathname]);
}
